/**
 * Runs `send` (an analytics emit) so its Amplitude event survives the page
 * going away. Called when the page is already hidden — the moment Web
 * Vitals reports its final CLS / INP / LCP: the SDK's default `fetch` queue
 * flushes on a timer the browser may never run, so the transport switches to
 * `sendBeacon` and the queue flushes at once. Once the SDK script has loaded
 * these calls exist; before it they are absent and the event waits in the
 * command queue like any other. Never throws (safe-client rule #2).
 */
export function sendFromHiddenPage(send: () => void): void {
  try {
    window.amplitude?.setTransport?.('beacon')
  } catch {
    // vendor threw — keep the default transport
  }
  send()
  try {
    window.amplitude?.flush?.()
  } catch {
    // vendor threw — the timer flush may still make it
  }
}
